import { IDetalleEquipoDTO, IEquipoKomatsu, IRequestActualizarEquipo } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo"
import { NeutralColors,Spinner,Text } from "@fluentui/react"
import { IntegracionService } from "../../../../../services/auxiliar/IntegracionService"
import { useEffect, useState } from "react"
import { HistoricoEstadoEquipoService } from "../../../../../services/auxiliar/HistoricoEstadoEquipo"

interface IEquipoInfo{
    equipo:IDetalleEquipoDTO,

}
export const EquipoInfo=(props:IEquipoInfo)=>{
    const [hora,setHora]=useState<string>('0')
    const [loading,setLoading]=useState(false)
    const [color,setColor]=useState<string>('#00B050')
    const GetHora=()=>{
        setLoading(true)
        IntegracionService.GetEstado(props.equipo.codigo).then((res)=>{
            if(res.status==200){
                 const resultado:IEquipoKomatsu=res.data
                 setHora(resultado.horasCalculadas)
                 setLoading(false)
                 setColor(resultado.colorFigura)
            }
        }).catch((e)=>{
            setHora('0')
            setLoading(false)
        })
    }
    useEffect(()=>{
        GetHora()
    },[])
    const numeroEncaso = (num) => {
        if (num >= 10000) {
          return `${(num / 10000).toFixed(1)}k`;
        }
        return num.toString();
      };
      const getSize = (value) => {
        if (value.length > 4) {
          return '7rem';     
        } else if (value.length > 3) {
          return '6.5rem'; 
        }
        return '6rem';    
      }
  
    return(
        <div style={{ borderBottom: "1px solid #ccc", 
        padding:'30px',alignItems:'center',display:'flex' ,justifyContent:'space-between'} }>
        
        <div style={{width: getSize(hora),height: '6rem',borderRadius: '50%',backgroundColor: color,
        display: 'flex',flexDirection: 'column',alignItems: 'center',justifyContent: 'center',color: 'white'
        }}>
        {loading ? (<Spinner/>):(<>
       <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{hora}</span>
       <span style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>Hours</span></>)}
       </div>

       <div style={{display:'flex',width:'90%',flexDirection:'column'}}>

       <div  style={{display: 'flex',justifyContent:'space-between',padding: '1.5rem'}}>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.codigo}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Equipo</Text>
       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.operador}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Operador Actual</Text>
       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.horometro}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Horómetro</Text>

       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.fecha}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Fecha</Text>
       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.turno}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Turno</Text>
       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.codigoRazon}-{props.equipo.descripcionRazon}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Razón</Text>
       </div>

       </div>


       <div style={{borderTop: "1px solid #ccc",display: 'flex',padding: '1.5rem'}}>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.modelo}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Modelo</Text>
       </div>
       <div style={{display: 'flex',
        flexDirection: 'column',
        marginRight: '2rem'}}>
        <Text variant="large" styles={{ root: {color: NeutralColors.black,fontWeight: 'bold'} }}>{props.equipo.tipoEquipo}</Text>
        <Text variant="medium" styles={{ root: {color: NeutralColors.gray130, marginTop: '0.75rem'} }}>Equipo</Text>
       </div>
       </div>

       
       </div>
       
        </div>
    )
}